module.exports = __webpack_public_path__ + "static/psy-7899f1b82143fef18b70eefccaf9f641.png";